import {
  SAVE_WIKI_DATA,
  FETCH_WIKI_DATA,
  MODIFY_WIKI_DATA,
  DELETE_WIKI_DATA,
} from "../actions/types";
import jwt_decode from "jwt-decode";
const INITIAL_STATE = {
  wikiList: [],
};
const decoded = localStorage.getItem("auth_token") ? jwt_decode(localStorage.getItem("auth_token")) : null;
const role = decoded ? (decoded.roles ? decoded.roles[0] : decoded.lab || '') : '';
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_WIKI_DATA:
      return {
        ...state,
        wikiList: action.payload,
      };
    case SAVE_WIKI_DATA:
      return {
        ...state,
        wikiList:
          role == "Lab.Tech"
            ? [action.payload].concat(...state.wikiList)
            : [
                [action.payload].concat(...state.wikiList[0]),
                [...state.wikiList[1]],
              ],
      };
    case DELETE_WIKI_DATA:
      return {
        ...state,
        wikiList:
          role == "Lab.Tech"
            ? [
                ...state.wikiList.filter(
                  (val) => val.id !== action.payload.data
                ),
              ]
            : [
                [
                  ...state.wikiList[0].filter(
                    (val) => val.id !== action.payload.data
                  ),
                ],
                [...state.wikiList[1]],
              ],
      };
    case MODIFY_WIKI_DATA:
      if (action.payload) {
        const wikiList =
          role == "Lab.Tech"
            ? state.wikiList.filter((val) => val.id != action.payload.id)
            : state.wikiList[0].filter((val) => val.id != action.payload.id);
        return {
          ...state,
          wikiList:
            role == "Lab.Tech"
              ? [ action.payload, ...wikiList]
              : [[action.payload, ...wikiList ], [...state.wikiList[1]]],
        };
      } else return state;
    default:
      return state;
  }
};
